import { render, staticRenderFns } from "./FileUploadButton.vue?vue&type=template&id=5330f824&scoped=true&"
import script from "./FileUploadButton.vue?vue&type=script&lang=js&"
export * from "./FileUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadButton.vue?vue&type=style&index=0&id=5330f824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330f824",
  null
  
)

export default component.exports